<div class="modal" id="license-selector-dialog" role="dialog">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h3>Software License Agreement for RIFM Members</h3>
                <div class="nav navbar-left navbar-form">
                    <button class="btn btn-primary navbar-btn" type="button" (click)="onAccept(true)" >Accept</button>
                    <button class="btn btn-primary navbar-btn" type="button" (click)="onAccept(false)">Do Not Accept</button>
                </div>
            </div>
            <div class="modal-body">
                <div [innerHTML]="_rifmProductLicense"></div>
            </div>
        </div>
    </div>
</div>
